export const fetchAllCategoriesQueryKey = () => ['categories'];
